import { render } from "./InputImageUpload.vue?vue&type=template&id=e21896f8&scoped=true"
import script from "./InputImageUpload.vue?vue&type=script&lang=ts"
export * from "./InputImageUpload.vue?vue&type=script&lang=ts"

import "./InputImageUpload.vue?vue&type=style&index=0&id=e21896f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e21896f8"

export default script